import {
  Combobox,
  ComboboxItem,
  Group,
  InputBase,
  Text,
  useCombobox,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconCheck } from "@tabler/icons-react";
import i18n from "src/i18n";

import { StyledInputBase } from "@components/ConsultationSelect/ConsultationSelect.styled";

import { mq } from "@styles/Utilities.styled";

import FrFlag from "@assets/icons/fr.svg?react";
import EnFlag from "@assets/icons/gb.svg?react";

import { StyledDiv } from "./LanugageSelect.styled";


const data = [
  { label: "English", value: "en-US" },
  { label: "French", value: "fr" },
];

function SelectOption({ value }: ComboboxItem) {
  return (
    <Group gap={"xs"}>
      {value === "en-US" ? (
        <EnFlag style={{ width: 20, height: 20 }} />
      ) : (
        <FrFlag style={{ width: 20, height: 20 }} />
      )}
      <Text fz={14}>
        {value === "en-US" ? i18n.t(`english`) : i18n.t(`french`)}
      </Text>
    </Group>
  );
}

function SelectedOption({ value }: ComboboxItem) {
  return (
    <Group gap="xs">
      {value === "en-US" ? (
        <EnFlag style={{ width: 20, height: 20 }} />
      ) : (
        <FrFlag style={{ width: 20, height: 20 }} />
      )}
      <StyledDiv>
        <Text fz={14}>
          {value === "en-US" ? i18n.t(`english`) : i18n.t(`french`)}
        </Text>
      </StyledDiv>
    </Group>
  );
}

export const LanguageSelect = () => {
  const isLarge = useMediaQuery(`${mq.large1}`);
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  // const [value, setValue] = useState<string | null>(appLang);
  const selectedOption = data.find(item => item.value === i18n.language);

  const options = data.map(item => (
    <Combobox.Option
      value={item.value}
      key={item.value}
      active={item.value === i18n.language}>
      <Group gap="xs" justify="space-between">
        <SelectOption {...item} />
        {item.value === i18n.language && (
          <IconCheck size={16} color={"var(--mantine-color-black)"} />
        )}
      </Group>
    </Combobox.Option>
  ));

  return (
    <Combobox
      store={combobox}
      width={isLarge ? 196 : "max-content"}
      withinPortal={true}
      zIndex={99}
      onOptionSubmit={val => {
        i18n.changeLanguage(val);
        combobox.closeDropdown();
      }}>
      <Combobox.Target>
        <StyledInputBase>
          <InputBase
            component="button"
            w={{ base: "90%", lg1: "85%" }}
            mx={"auto"}
            mb="xs"
            type="button"
            pointer
            rightSection={<Combobox.Chevron />}
            rightSectionPointerEvents="none"
            onClick={() => combobox.toggleDropdown()}>
            {
              selectedOption ? <SelectedOption {...selectedOption} /> : null
              // (
              //   <Input.Placeholder></Input.Placeholder>
              // )
            }
          </InputBase>
        </StyledInputBase>
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options>{options}</Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
};
